import two from '../assets/home/18.png';
import three from '../assets/home/16.png';
import four from '../assets/home/15.png';
import five from '../assets/home/17.png';


const offercontent = [
    {
        title: "Free Delivery Across the US!",
        subtitle: "Free delivery for all orders above $100",
        image: two
    },
    {
        title: "100% Satisfaction Guarantee!",
        subtitle: "Providing help in case of dissatisfaction",
         image: three
    },
    {
        title: "Secure Payments",
        subtitle: "We use safest payment technologies",
        
        image: four
    },
    {
        title: "Top-Notch Support",
        subtitle: "Chat with us if you’ve any questions",
      

         image: five
    },
];

export default offercontent;